import { createSlice } from '@reduxjs/toolkit'

import { IPaymentState, IPaymentReducers } from './payment.types'

const initialState: IPaymentState = {
  loading: false,
  info: null,
}

const { actions, reducer } = createSlice<IPaymentState, IPaymentReducers, 'payment'>({
  name: 'payment',
  initialState,
  reducers: {
    checkBalanceAfterConnect: (state) => {
      state.loading = true
    },
    setPaymentInfo: (state, action) => {
      state.loading = false
      state.info = action.payload.info
    },
    clearPaymentInfo: (state) => {
      state.loading = false
      state.info = null
    },
  },
})

export { actions as PaymentActions }

export { reducer as paymentReducer }
